export const PRICE_INCLUDE_VI = `Chỗ ở theo lịch trình
Các bữa ăn theo lịch trình (B = Bữa sáng, L = Bữa trưa, D = Bữa tối)
Vé máy bay hoặc vé tàu cho các tuyến đường được liệt kê trong lịch trình
Hướng dẫn viên địa phương nói tiếng Anh và dịch vụ đưa đón trong các tour
Phí vào cửa các điểm tham quan đã nêu.
Phí dịch vụ và thuế VAT của chính phủ.
1 chai nước mỗi ngày (tại khách sạn hoặc trong tour)

Accommodation as in the itinerary
Meals as mentioned in the itinerary (B= Breakfast, L= Lunch, D= Dinner)
Flight or train ticket for the routes as listed in the itinerary
Group local based English-speaking guide and transfer on tours
Entrance fees for mentioned visits.
Service charges and government VAT tax.
1 bottle of water per day (at hotel or on tour)`;

export const PRICE_EXCLUDE_VI = `Phí dán tem visa
Các bữa ăn khác ngoài những bữa được đề cập trong lịch trình
Phí giặt là, điện thoại
Chi phí cá nhân
Tiền boa cho hướng dẫn viên/lái xe
Bảo hiểm du lịch

Visa stamp fee
Other meals than mentioned in the itinerary
Laundry, telephone calls
Expenditure of personal expenses
Gratuities for tour guides/drivers
Travel insurance`;

export const PRICE_TEMPLATE = `Tổng cộng 20000000 VND
Khoản tiền đặt cọc đầu tiên: 10000000 VND đã được thanh toán qua cổng thanh toán Onepay (đã bao gồm phí giao dịch)
Khoản thanh toán cuối cùng: 10000000 VND đã được thanh toán bằng tiền mặt.

Price: 20000000 VND in total
First deposit: 10000000 VND was paid Via Onepay Payment Gateway included transaction fee
Final payment: 10000000 was paid in cash VND`;
